module.exports = __webpack_public_path__ + "img/swipe-horizontal.df2a1e20.svg";